import { get, post, put, del } from "../request";

const PREFIX = "/contentAdmin/activityCenterAdmin";

/** 分页查询活动中心 */
export function getActivityList(params) {
  return get(`${PREFIX}/list`, params);
}

/** 活动中心详情 */
export function getActivityDetail(activityId) {
  return get(`${PREFIX}/${activityId}`);
}

/** 新增活动中心 */
export function addActivity(data) {
  return post(PREFIX, data);
}

/** 修改活动中心 */
export function updateActivity(data) {
  return put(PREFIX, data);
}

/** 删除活动中心 */
export function deleteActivity(activityIds) {
  return del(`${PREFIX}/${activityIds}`);
}



// WEBPACK FOOTER //
// ./src/api/content/activity.js